import { render, staticRenderFns } from "./homeEn.vue?vue&type=template&id=29b792fa&"
import script from "./homeEn.vue?vue&type=script&lang=js&"
export * from "./homeEn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports